import * as THREE from "three"
import { servObj } from "./init_glob.js"
import {applyFasadTexture, applyRoofColor, applyDrainageSystemColor, applyWindowsDoorsColor, applyPlinthTexture} from "./house_configurate.js"
import {applyFenceTexture} from "./fence_configurate.js"
import {applyTile} from "./tile_configurate.js"
import {reCreateGroupMenu} from "./template"
import {hideLoaderElement, showLoaderElement} from "./loaderElement.js"

document.querySelector('[data-new-project-action="new"]').addEventListener("pointerdown", () => {
    servObj.isInfoWindowHide = undefined

    showLoaderElement(true)
    servObj.tile = structuredClone(servObj.defaultTile)

    applyRoofColor(servObj.defaultHouse.roofColor)
    applyFasadTexture(servObj.defaultHouse.fasadTexture)
    applyDrainageSystemColor(servObj.defaultHouse.drainageSystemColor)
    applyWindowsDoorsColor(servObj.defaultHouse.windowsDoorsColor)
    applyPlinthTexture(servObj.defaultHouse.plinthTexture)
    applyFenceTexture(servObj.defaultFence.textureName, servObj.defaultFence.rusTextureName, false)

    applyTile(() => hideLoaderElement(true), true)
    reCreateGroupMenu(servObj.defaultTile.activeGroupName)

    document.querySelectorAll('#house-roof-colors input[name="home-dec-color"]').forEach(el => el.checked = el.value == servObj.defaultHouse.roofColor)
    document.querySelectorAll('#drainage-system-colors input[name="gutter-color"]').forEach(el => el.checked = el.value == servObj.defaultHouse.drainageSystemColor)
    document.querySelectorAll('#windows-doors-colors input[name="window-door-color"]').forEach(el => el.checked = el.value == servObj.defaultHouse.windowsDoorsColor)
    document.querySelectorAll('#plinth-textures input[name="home-dec-roof"]').forEach(el => el.checked = el.value == servObj.defaultHouse.plinthTexture)
    document.querySelectorAll('#house-fasad-textures input[name="home-dec-roof"]').forEach(el => el.checked = el.value == servObj.defaultHouse.fasadTexture)

    document.querySelector(`#paving-slabs__${servObj.defaultTile.activeGroupName}`).checked = true
    document.querySelector(`#paving-slabs__pattern_${servObj.defaultTile.activeTilePattern.pathName}`).checked = true
    document.querySelector(`#facture option[value="${servObj.defaultTile.activeFacture.pathName}"]`).selected = true
    document.querySelector(`#paving-slabs__collection_${servObj.defaultTile.activeCollection.pathName}`).checked = true
    document.querySelector(`#paving-slabs__thickness_${servObj.defaultTile.activeDepth}`).checked = true
    document.querySelector(`#option-color input[value="${servObj.defaultTile.activeColor}"]`).checked = true


    // fence
    document.querySelector(`#option-block-pattern [value="${servObj.defaultFence.type}"]`).checked = true
    document.querySelector(`#block-option-color [value="${servObj.defaultFence.textureName}"]`).checked = true

    const fenceFullInstanced = servObj.scene.getObjectByName("fence_brick_instanced")
    const fenceFull = servObj.scene.getObjectByName("fence_brick")
    const fenceCutInstanced = servObj.scene.getObjectByName("fence_half_brick_instanced")
    const fenceCut = servObj.scene.getObjectByName("fence_half_brick")

    fenceFullInstanced.visible = false
    fenceFull.visible = false
    fenceCutInstanced.visible = true
    fenceCut.visible = true
    
})
